module.exports = __webpack_public_path__ + "static/img/virtual-reality.435e9a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/virtual-reality.jpg
// module id = 0Pxx
// module chunks = 3